import { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams, Outlet, Link } from "react-router-dom";
import { Menu, ConfigProvider, Dropdown, Space, Button, message } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import api from "@/api";
import { findDeep, getDevicePluginDetail, format } from "@/utils";

import dataJson from "@/../public/data.json";

const prefix = "myDevicePluginDetail";
import { cloneDeep } from "lodash-es";
import { publicPath } from "@/utils/base";
import "./index.less";

function myDevicePluginDetail() {
  const { add, my_device_plugin_detail, release, req_err } = dataJson;
  const [current, setCurrent] = useState("");
  const [dropdownItems, setDropdownItems] = useState<any[]>([]);
  const [dropdownList, setDropdownList] = useState([]);
  const [dropdownCur, setDropdownCur] = useState("");
  const [dropdownSelect, setDropdownSelect] = useState("");
  const [isAddVersion, setIsAddVersion] = useState<boolean>(true);

  const devicePluginDetail = useSelector((state: any) => state.devicePluginDetail);

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const { id } = useParams();

  const onClick = (e: any) => {
    if (current === e.key) {
      return;
    }
    setCurrent(e.key);
    // if (e.key === "versionmanage") {
    //   getDevicePluginDetail(devicePluginDetail?.histories[0].id, () => {
    //     navigate(`${publicPath}${e.item.props.url}/${devicePluginDetail?.histories[0].id}`);
    //   });
    // } else {

    // }
    getDevicePluginDetail(devicePluginDetail?.id, () => {
      navigate(`${publicPath}${e.item.props.url}/${devicePluginDetail.id}`);
    });
  };

  const dropdownOnClick = (e: any) => {
    setDropdownSelect(e.key);

    getDevicePluginDetail(e.key, () => {
      navigate(`${publicPath}/my_device_plugin_detail/versionmanage/${e.key}`);
    });
  };

  const upgrade = async () => {
    const firstShowMode = findDeep(release.show_mode_arr, devicePluginDetail?.histories[0]?.showMode);
    if (devicePluginDetail?.histories?.length > 1 && firstShowMode.isUpgrade) {
      navigate(`${publicPath}/my_device_plugin_detail/versionmanage/${devicePluginDetail?.histories[0].id}`);
      getDevicePluginDetail(devicePluginDetail?.histories[0].id);
    } else {
      try {
        const res: any = await api.upgradeVersionDevicePlugin({ id: devicePluginDetail?.currentId });
        if (res?.code == 200) {
          navigate(`${publicPath}/my_device_plugin_detail/versionmanage/${res.data.id}`);
          getDevicePluginDetail(res.data.id);
        } else {
          message.error(res.msg);
        }
      } catch (errorInfo: any) {
        message.error(errorInfo?.response?.data?.msg || req_err);
        return;
      }
    }
  };

  const to = (id: string, cur = current) => {
    switch (cur) {
      case "info":
        navigate(`${publicPath}/my_device_plugin_detail/info/${id}`);
        break;
      case "versionmanage":
        navigate(`${publicPath}/my_device_plugin_detail/versionmanage/${id}`);
        break;
      default:
        null;
    }
  };

  const getDropdownlist = async () => {
    try {
      const res: any = await api.getDevicePluginNoPage({
        page: 1,
      });
      if (res.code === 200) {
        const dataCopy = cloneDeep(res.data);
        const list = dataCopy.map((item: any) => {
          return {
            key: item.id,
            name: item.name,
            label: <a onClick={() => to(item.id)}>{item.name}</a>,
          };
        });
        setDropdownList(list || []);
        const cur = dataCopy?.find((item: any) => item.firstAppId === id);
        setDropdownCur(cur?.name || "");
      } else {
        message.error(res.msg || req_err);
      }
    } catch (errorInfo: any) {
      console.error(errorInfo);
    }
  };

  useEffect(() => {
    if (devicePluginDetail) {
      const resData = cloneDeep(devicePluginDetail);
      const resShowMode = findDeep(release.show_mode_arr, resData?.showMode);
      // const firstShowMode = findDeep(release.show_mode_arr, devicePluginDetail?.histories[0]?.showMode);
      // 有升级场景，在新版本页面，按钮要受到旧版本状态影响
      if (resShowMode?.isUpgrade && resData?.histories?.length > 1) {
        const oldShowMode = resData?.histories[1]?.showMode;
        resData.baseBtns = resShowMode?.btnsByOld[oldShowMode];
      } else {
        resData.baseBtns = resShowMode?.baseBtns;
      }
      // if (resData?.showMode === "HISTORY" || (firstShowMode?.isUpgrade && resData.id !== firstShowMode?.id)) {
      //   setIsAddVersion(false);
      // } else {
      setIsAddVersion(!resData.baseBtns?.includes("upgrade"));
      // }

      getDropdownlist();

      const newDropdownItems: any[] = devicePluginDetail?.histories?.map((item: any) => {
        const showModeItem = findDeep(release.show_mode_arr, item?.showMode);
        return {
          key: item.id,
          label: (
            <div className={`${prefix}-dropdownItems`}>
              <div className={`${prefix}-dropdownItems-version one-line-ellipsis`} title={item.version}>
                {item?.version ? (
                  <div className={`${prefix}-dropdownItems-version-text one-line-ellipsis`}>
                    {my_device_plugin_detail.version_v}
                    {item.version}
                  </div>
                ) : (
                  <div className={`${prefix}-dropdownItems-version-text`}>{my_device_plugin_detail.new_version}</div>
                )}
                <div className={`${prefix}-dropdownItems-version-status`} style={{ color: showModeItem.textColor }}>
                  {showModeItem.title}
                </div>
              </div>
              <div className={`${prefix}-dropdownItems-time`}>
                {format(new Date(Number(item.createTime)), "yy年MM月dd日 HH:mm")}
              </div>
            </div>
          ),
        };
      });
      setDropdownItems(newDropdownItems || []);
    }
  }, [devicePluginDetail]);

  useEffect(() => {
    const pathArr = pathname.split("/");
    setCurrent(pathArr[pathArr.length - 2]);
    setDropdownSelect(id || "");
    getDevicePluginDetail(id);
  }, [pathname]);
  return (
    <div className={prefix}>
      <div className={`${prefix}-menu-wrap`}>
        <ConfigProvider
          theme={{
            components: {
              Menu: {
                itemSelectedBg: "#0A59F7",
                itemSelectedColor: "#fff",
                itemBorderRadius: 0,
                iconSize: 14,
                itemHeight: 64,
                fontSize: 18,
              },
            },
          }}
        >
          <Menu
            onClick={onClick}
            mode="inline"
            items={my_device_plugin_detail.menu}
            defaultOpenKeys={["distribute"]}
            selectedKeys={[current]}
            className={`${prefix}-menu`}
          />
        </ConfigProvider>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Button: { colorPrimary: "#0A59F7" },
            Tabs: { colorPrimary: "#0A59F7" },
          },
        }}
      >
        <div className={`${prefix}-top`}>
          <div className={`${prefix}-breadCrumb`}>
            <Link to={`${publicPath}/staging`} state={{ tabKey: "4" }} className={`${prefix}-breadCrumb-link`}>
              {my_device_plugin_detail.plugin_text}
            </Link>
            &nbsp;/&nbsp;
            <Link to={`${publicPath}/my_device_plugin`} className={`${prefix}-breadCrumb-link`}>
              {my_device_plugin_detail.my_device_plugin_text}
            </Link>
            &nbsp;/&nbsp;
            <Dropdown menu={{ items: dropdownList, style: { maxHeight: "70vh" } }}>
              <Space style={{ color: "#1A1A1A" }}>
                {devicePluginDetail?.histories[0]?.name || dropdownCur || "--"}
                <DownOutlined />
              </Space>
            </Dropdown>
          </div>
          {current === "versionmanage" ? (
            <div className={`${prefix}-top-right`}>
              <Button type="link" disabled={isAddVersion} onClick={upgrade}>
                {add + my_device_plugin_detail.version}
              </Button>
              <Dropdown
                menu={{
                  items: dropdownItems,
                  selectable: true,
                  selectedKeys: [dropdownSelect],
                  onClick: dropdownOnClick,
                }}
                overlayClassName={`${prefix}-dropdown-overlay`}
              >
                <span className={`${prefix}-dropdown`}>
                  <Space>
                    {my_device_plugin_detail.version}
                    <DownOutlined />
                  </Space>
                </span>
              </Dropdown>
            </div>
          ) : (
            <span></span>
          )}
        </div>

        <Outlet />
      </ConfigProvider>
    </div>
  );
}

export default myDevicePluginDetail;
